import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { INCIDENT_CATEGORY_API } from "./apiRoutes";

interface UseGetProps {
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getIncidentCategoryDropdown = async (communityId: string) =>
  await axiosAuth.get(`${INCIDENT_CATEGORY_API(communityId)}/dropdown`);

const useGetIncidentCategoryDropdown = ({
  communityId,
  queryParams,
}: UseGetProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["incident-category-dropdown", communityId],
    queryFn: () => getIncidentCategoryDropdown(communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetIncidentCategoryDropdown;
